"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pending = void 0;
const react_1 = __importDefault(require("react"));
const ErrorText_1 = require("../../atoms/ErrorText/ErrorText");
const Pending = ({ loading, loader, error, renderError, children }) => {
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null, loader);
    }
    if (error) {
        if (renderError) {
            return react_1.default.createElement(react_1.default.Fragment, null, renderError);
        }
        return react_1.default.createElement(ErrorText_1.ErrorText, null, typeof error === 'string' ? error : 'An error occurred. Please try again later.');
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.Pending = Pending;
